module.exports = __webpack_public_path__ + "static/media/cyclingjersey.82d2dbfa.jpg";